import { render } from "./Assorted_record.vue?vue&type=template&id=b0ce43ce&ts=true"
import script from "./Assorted_record.vue?vue&type=script&lang=ts"
export * from "./Assorted_record.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__